'use client'
import { ButtonRoundStyle, Image, PopupWrapper } from '@/components'
import { URL_ICON, URL_IMG } from '@/constants/ui'
import { Box, Button, Chip, Grid, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import { Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { ProductSmallItem } from './product-small-item'

interface StylingItemProps {
  item: {
    title: string
    imageMain: string
    heightModel: number
    weightModel: number
    products: any[]
  }
  imageMain: string
  isComingSoon?: boolean
  products?: Product[]
}

export default function StylingItem({ imageMain, item, isComingSoon, products }: StylingItemProps) {
  const [open, setOpen] = useState(false)

  const handleClick = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }
  return (
    <Grid size={{ xs: 12, sm: 4, xl: 3 }}>
      <Box
        sx={{
          position: 'relative',
          borderRadius: '0.5rem',
          overflow: 'hidden',
          '&:hover button': {
            opacity: 1,
            visibility: 'visible',
          },
        }}
      >
        <Image src={imageMain} alt="Style" ratio="3/4"></Image>
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            width: '100%',
            padding: '0.5rem',
            zIndex: 1,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {isComingSoon && (
            <Chip
              label="Sắp ra mắt"
              size="small"
              variant="filled"
              sx={{
                height: 30,
                fontSize: '0.875rem',
                fontWeight: 600,
                backgroundColor: 'warning.main',
                color: 'white',
                width: 'fit-content',
              }}
              icon={
                // eslint-disable-next-line @next/next/no-img-element
                <img
                  src={URL_ICON + 'ic-clock.svg'}
                  style={{ width: 'auto', height: '1rem' }}
                  alt="Clock Icon"
                />
              }
            />
          )}
          <ButtonRoundStyle
            variant="outlined"
            onClick={handleClick}
            sx={{
              fontSize: '0.875rem',
              padding: {
                xs: '0.5rem 1rem',
                xl: '0.75rem 1rem',
              },
              borderColor: 'white',
              transition: 'all .3s ease-in-out',
              color: 'white',
              marginTop: 'auto',
              opacity: {
                xs: 1,
                xl: 0,
              },
              visibility: {
                xs: 'visible',
                xl: 'hidden',
              },
              '&:hover': {
                backgroundColor: 'primary.main',
                borderColor: 'primary.main',
              },
            }}
          >
            Xem set đồ
          </ButtonRoundStyle>
        </Box>
      </Box>

      <PopupWrapper isOpen={open} handleClose={handleClose} width="1040px">
        <Box
          sx={{
            '& .swiper': {
              borderRadius: '0.5rem',
              overflow: 'hidden',
            },
            '& .swiper-button-prev, & .swiper-button-next': {
              color: '#fff',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              width: '36px',
              height: '36px',
              borderRadius: '50%',
              '&::after': {
                fontSize: '16px',
              },
            },
            '& .swiper-pagination-bullet': {
              backgroundColor: '#fff',
            },
            '& .swiper-pagination-bullet-active': {
              backgroundColor: 'primary.main',
            },
            margin: {
              xs: '-1rem -1rem 0',
              md: '0',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              margin: '0 -0.8rem',
              rowGap: '1.2rem',
              flexWrap: 'wrap',
            }}
          >
            <Box
              sx={{
                width: {
                  xs: '100%',
                  md: '50%',
                },
                padding: '0 0.8rem',
              }}
            >
              <Swiper
                modules={[Navigation, Pagination]}
                navigation
                pagination={{ clickable: true }}
                spaceBetween={10}
                slidesPerView={1}
              >
                <SwiperSlide>
                  <Image src={imageMain} alt={`Style ${item?.title}`} ratio="3/4" />
                </SwiperSlide>
              </Swiper>
            </Box>
            <Box
              sx={{
                width: {
                  xs: '100%',
                  md: '50%',
                },
                padding: '0 0.8rem',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  gap: 1.2,
                  px: {
                    xs: 1,
                    md: 0,
                  },
                }}
              >
                <Typography
                  variant="h6"
                  fontSize={{ xs: '1.5rem', md: '2rem' }}
                  fontWeight={600}
                  lineHeight={1.2}
                >
                  {item?.title}
                </Typography>
                <Typography variant="body1" color="text.primary">
                  Thông tin người mẫu:
                  <br />
                  Cao: {item?.heightModel}cm
                  <br />
                  Cân nặng: {item?.weightModel}kg
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    border: '1px solid #E0E0E0',
                    borderRadius: '0.5rem',
                    overflow: 'hidden',
                  }}
                >
                  <Box
                    sx={{
                      maxHeight: '20rem',
                      overflowY: 'auto',
                    }}
                  >
                    {products?.map((product, index) => {
                      const configOptiuons = item.products.find((p) => p.sku === product.sku)
                      return (
                        <ProductSmallItem key={index} product={product} configOptiuons={configOptiuons} />
                      )
                    })}
                  </Box>
                </Box>
                {/* <Stack direction="row" spacing={1} alignItems="center" color={'error.main'}>
                  <Image
                    src={URL_IMG + 'ic-sale.svg'}
                    style={{
                      width: '1.6rem',
                      height: '1.6rem',
                      flexShrink: 0,
                    }}
                    alt="Discount Icon"
                  />

                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: '0.875rem',
                      fontWeight: 700,
                    }}
                  >
                    Vì bạn có hứng thú với set đồ này nên bạn được giảm 500.000Đ.
                  </Typography>
                </Stack> */}
                {/* <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    borderRadius: '0.5rem',
                    textTransform: 'none',
                    padding: '0.75rem',
                    fontSize: '1rem',
                    backgroundColor: 'primary.main',
                    boxShadow: 'unset',
                    transition: 'all .3s ease-in-out',
                    marginTop: 'auto',
                    border: '0.1rem solid transparent',
                    '&:hover': {
                      backgroundColor: '#fff',
                      color: 'primary.main',
                      boxShadow: 'unset',
                      borderColor: 'primary.main',
                    },
                  }}
                >
                  MUA NGAY SET ĐỒ - 1.250.000Đ{' '}
                  <Typography
                    component="span"
                    sx={{
                      textDecoration: 'line-through',
                      marginLeft: '0.5rem',
                      fontSize: '0.875rem',
                      color: '#9B9A99',
                    }}
                  >
                    1.750.000Đ
                  </Typography>
                </Button> */}
              </Box>
            </Box>
          </Box>
        </Box>
      </PopupWrapper>
    </Grid>
  )
}
